import React from 'react';
import GenericInput from '../../common/input/GenericInput';
import Email from '../../common/input/Email';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { RX, EPIC, GRANT, RXEPIC } from "../../../constants/textConstants";
import * as ProxyHelper from "../ProxyHelper";

class AccessorInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: ''
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AccessorInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    isValid() {
        const { accessorName, isValid, isConfirmedEmailMatching } = this.props;
        if (accessorName && accessorName !== "" && isValid.email && isValid.confirmEmail && isConfirmedEmailMatching) {
            this.setState({ showAsInvalid: false });
            logUI(`MBHWeb.UI.AccessorInfo.GetProxyTermsAndConditions.IsValid`, new Date(), Tools.getURLPath());
            this.props.getProxyTermsAndConditions();
            return true;
        }
        if (accessorName && accessorName !== "" && isValid.email && isValid.confirmEmail && !isConfirmedEmailMatching) {
            this.setState({
                error: "Please correct the required information.", showAsInvalid: true
            });
        } else {
            this.setState({
                error: "Please enter the required information.", showAsInvalid: true
            });
        }

    }

    onGrantAccess = () => {
        if (this.isValid()) {
            this.props.onGrantAccess();
        }

    }

    getHeadings() {
        const { healthrecord, pharmacy, isProgressBar} = this.props;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        let heading = "";
        let subHeading = "";
        const defaultSubHeading = "The person you grant access to must be at least 18 years old."
        switch (proxySource) {
            case RXEPIC: {
                heading = "Who are you granting access to?";
                subHeading = defaultSubHeading;
                break;
            }
            case EPIC: {
                heading = "Who are you granting medical records access to?";
                subHeading = isProgressBar ? defaultSubHeading : "They must be at least 18 years old and will be able to book appointments, view exam results & message with your doctor.";
                break;
            }
            case RX: {
                heading = "Who are you granting BSW pharmacy access to?";
                subHeading = isProgressBar ? defaultSubHeading : "They must be at least 18 years old and will be able to view & refill your prescriptions from a BSW pharmacy.";
                break;
            }
            default: {
                break;
            }
        }
        return {Heading: heading, SubHeading: subHeading};
    }

    render() {
        const { isProgressBar, accessorName, email, isValid, confirmEmail, isConfirmedEmailMatching} = this.props;
        const { error } = this.state;
        const headings = this.getHeadings();
        const showEmailDoNotMatch = !isConfirmedEmailMatching && isValid.email && isValid.confirmEmail;

        return (<div className="accessor-info-container sm-width-step" style={this.props.style}>
            <div className="row">
                <div className="col-12">
                    <h1 className={"step-heading step-heading-md" + (isProgressBar ? "" : " no-prog-bar")}>{headings.Heading}</h1>
                </div>
                <div className="col-12">
                    <p className="step-description text-center">{headings.SubHeading}</p>
                </div>
                <div className="col-12 step-form-container">
                    <div className="row">
                        <div className="col-12 form-group">
                            <GenericInput id="accessorName" placeholder="Accessor's Name" value={accessorName} name="accessorName" required
                                onChange={(e, v, isValid) => { this.setState({ error: '' }); this.props.onInputChange('accessorName', v, isValid); }} ref="accessorName" autoFocus
                                showAsInvalid={this.state.showAsInvalid && !isValid.accessorName}
                            />
                        </div>
                        <div className="col-12 form-group">
                            <div className="row">
                                <div className={"col-12 col-sm-6 form-group" + (isConfirmedEmailMatching ? " input-matches" : "")}>
                                    <Email id="email" placeholder="Email Address" value={email} name="email" required
                                        onChange={(e, isValid) => { this.setState({ error: '' }); this.props.onInputChange('email', e.target.value, isValid); }}
                                        showAsInvalid={(this.state.showAsInvalid && !isValid.email) || showEmailDoNotMatch}
                                    />
                                </div>

                                <div className={"col-12 col-sm-6 form-group" + (isConfirmedEmailMatching ? " input-matches" : "")}>
                                    <Email id="confirmEmail" placeholder="Confirm Email Address" value={confirmEmail} name="confirmEmail" required
                                        onChange={(e, isValid) => { this.setState({ error: '' }); this.props.onInputChange('confirmEmail', e.target.value, isValid); }}
                                        showAsInvalid={(this.state.showAsInvalid && !isValid.confirmEmail) || showEmailDoNotMatch}
                                    />
                                    {showEmailDoNotMatch &&
                                        <div className="input-error-msg">Email addresses do not match</div>
                                    }
                                </div>

                            </div>
                        </div>
                        <div className="col-12">
                            <div className={"text-center" + (!isProgressBar ? " footer-buttons" : "")}>
                                {(error !== "") &&
                                    <div className="error-msg">{error}</div>
                                }
                                {!isProgressBar && <input className="btn btn-primary" type="submit" value="CONTINUE" onClick={this.onGrantAccess} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default AccessorInfo;